module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Gc-Ha-Ic-Ja.f1978614.png";